import React from 'react'
import Navbar from "../../components/shared/Navbar/Navbar"
import Footer from "../../components/shared/Footer/Footer"
import WorkBanner from '../../components/pages/Work/WorkBanner/WorkBanner'
import SelectedProjects from '../../components/pages/Work/SelectedProjects/SelectedProjects'
import MoreWork from '../../components/pages/Work/MoreWork/MoreWork'
import Trusted from '../../components/pages/Work/Trusted/Trusted'
import HaveAProject from '../../components/pages/Insights/HaveAProject/HaveAProject'
import Impact from '../../components/pages/Work/Impact/Impact'
import { WorkPageProvider } from '../../context/WorkPageContext'

const Work = () => {
  return (
    <WorkPageProvider>
      <div>
        <Navbar />
        <WorkBanner />
        <SelectedProjects />
        <MoreWork />
        <Trusted />
        <Impact />
        <HaveAProject />
        <Footer/>
      </div>
    </WorkPageProvider>
  )
}

export default Work
